import React, { useState } from "react";

import { MyDecisionsGroup } from "./components/MyDecisionsGroup";

import { MyDecisionsGroupsProps } from "./types";

export const MyDecisionsGroups = ({
	groupedByManagerId,
	refreshingGroupIds,
	userID,
	expandedRowIdsByGroup,
	baseGridContext,
	onExpand,
	onCollapse,
	recommendedIncreasePercent,
	increaseValues,
	handleSubmitDecisions,
	gridRefs,
	columnDefs,
	notesPayloadKey,
	fullWidthCellRenderer,
	groupCannotBeSubmitted,
	cycleStatus,
}: MyDecisionsGroupsProps): React.ReactElement => {
	const [auditLogManagerId, setAuditLogManagerId] = useState<string | null>(null);

	return (
		<div className="w-full max-w-[1296px]">
			{[...groupedByManagerId]
				.sort((a, b) => {
					if (a.managerId === userID) return -1;
					if (b.managerId === userID) return 1;
					const nameA = a.users[0]?.managerName ?? "";
					const nameB = b.users[0]?.managerName ?? "";
					return nameA.localeCompare(nameB);
				})
				.map((group) => (
					<MyDecisionsGroup
						key={group.managerId}
						group={group}
						userID={userID}
						isRefreshingGroup={Boolean(refreshingGroupIds[group.managerId])}
						expandedRowId={expandedRowIdsByGroup[group.managerId] ?? null}
						baseGridContext={baseGridContext}
						onExpand={(rowId: string) => onExpand(group.managerId, rowId)}
						onCollapse={() => onCollapse(group.managerId)}
						recommendedIncreasePercent={recommendedIncreasePercent}
						increaseValues={increaseValues}
						onSubmitDecisions={() => handleSubmitDecisions(group.managerId)}
						gridRefs={gridRefs}
						columnDefs={columnDefs}
						notesPayloadKey={notesPayloadKey}
						fullWidthCellRenderer={fullWidthCellRenderer}
						showValidationBanner={String(groupCannotBeSubmitted ?? "") === String(group.managerId)}
						cycleStatus={cycleStatus}
						isAuditLogOpen={auditLogManagerId === group.managerId}
						onOpenAuditLog={() => setAuditLogManagerId(group.managerId)}
						onCloseAuditLog={() => setAuditLogManagerId(null)}
					/>
				))}
		</div>
	);
};
